// Import external
import { Component, Input } from '@angular/core';

@Component({

    selector: 'syn-boolean-ico',
    template: `
        <mat-icon *ngIf="check" class="syn-text--success" svgIcon="check"></mat-icon>
        <mat-icon *ngIf="!check" class="syn-text--danger" svgIcon="close"></mat-icon>
    `
})
export class BooleanIcoComponent {
    @Input() public check: boolean;
}
